import React, { useState, useEffect } from "react";
import { checkText } from 'smile2emoji';

// const emojiMap = {
//   '<3': '❤️',
//   '</3': '💔',
//   ':)': '😊',
//   ':(': '😢',
//   ':D': '😄',
//   ';)': '😉',
//   ':P': '😛',
//   ':O': '😮',
//   ':o': '😮',
//   ':|': '😐',
//   ':*': '😘',
//   ':\\': '😕',
//   ':/': '😕',
//   'XD': '😆',
//   'xD': '😆',
//   '>:(': '😡',
//   ':]': '😄',
//   ':3': '😸',
//   ':S': '😖',
//   ':@': '😠',
//   'o:)': '😇',
//   'O:)': '😇',
//   '>:O': '😲',
//   'B)': '😎',
//   ':-)': '🙂',
//   ':-(': '🙁',
//   ':-D': '😃',
//   ':-P': '😜',
//   ':-O': '😲',
//   ':-|': '😐',
//   '8)': '😎',
//   '8|': '😎',
//   '>:D': '😈',
//   '<_<': '😒',
//   '>_>': '😏',
//   '^_^': '😊',
//   '-_-': '😑',
//   'T_T': '😭',
//   'D:': '😧',
//   ':^)': '😊',
//   ':-*': '😘',
//   '*_*': '😍',
//   'O_O': '😲',
//   ':#': '🤐',
//   'X(': '😖',
//   ':^)': '😃',
//   ':>': '😏',
//   'D:<': '😠',
//   ':v': '😋',
//   ':b': '😛',
//   ':c': '😟',
//   ':d': '😁',
//   ':e': '😐',
//   ':f': '😬',
//   ':g': '😋',
//   ':h': '😊',
//   ':i': '😌',
//   ':j': '😇',
//   ':k': '😙',
//   ':l': '😕',
//   ':m': '😏',
//   ':n': '😶',
//   ':q': '😟',
//   ':r': '😮',
//   ':s': '😖',
//   ':t': '😞',
//   ':u': '😑',
//   ':w': '🙃',
//   ':y': '😃',
//   ':z': '😑',
//   '>:P': '😜',
//   '>:)': '😈',
//   ':^)': '😄',
//   ':@)': '😠',
//   ':8D': '😎',
//   ':O_o': '😳',
//   ':o_O': '😳',
//   '-__-': '😒',
//   ':y:': '👍',
//   ':n:': '👎',
//   ':clap:': '👏',
//   ':ok:': '👌',
//   ':wave:': '👋',
//   ':peace:': '✌️',
//   ':flex:': '💪',
//   ':heart:': '❤️',
//   ':star:': '⭐',
//   ':fire:': '🔥',
//   ':100:': '💯',
//   ':idea:': '💡',
//   ':gift:': '🎁',
//   ':party:': '🎉',
//   ':thumbsup:': '👍',
//   ':thumbsdown:': '👎',
//   ':sun:': '🌞',
//   ':moon:': '🌜',
//   ':rain:': '🌧️',
//   ':cloud:': '☁️',
//   ':flower:': '🌸',
//   ':tree:': '🌳',
//   ':earth:': '🌍',
//   ':cat:': '🐱',
//   ':dog:': '🐶',
//   ':bird:': '🐦',
//   ':fish:': '🐟',
//   ':horse:': '🐴',
//   ':unicorn:': '🦄',
//   ':panda:': '🐼',
//   ':bear:': '🐻',
//   ':lion:': '🦁',
//   ':tiger:': '🐯',
//   ':elephant:': '🐘',
//   ':zebra:': '🦓',
//   ':cow:': '🐄',
//   ':pig:': '🐖',
//   ':sheep:': '🐑',
//   ':monkey:': '🐒',
//   ':gorilla:': '🦍',
//   ':rabbit:': '🐰',
//   ':fox:': '🦊',
//   ':wolf:': '🐺',
//   ':deer:': '🦌',
//   ':bat:': '🦇',
//   ':whale:': '🐋',
//   ':dolphin:': '🐬',
//   ':shark:': '🦈',
//   ':octopus:': '🐙',
//   ':crab:': '🦀',
//   ':lobster:': '🦞',
//   ':shrimp:': '🦐',
//   ':butterfly:': '🦋',
//   ':bee:': '🐝',
//   ':ladybug:': '🐞',
//   ':ant:': '🐜',
//   ':spider:': '🕷️',
//   ':scorpion:': '🦂',
//   ':snake:': '🐍',
//   ':lizard:': '🦎',
//   ':crocodile:': '🐊',
//   ':turtle:': '🐢',
//   ':frog:': '🐸',
//   ':mushroom:': '🍄',
//   ':cactus:': '🌵',
//   ':palm:': '🌴',
//   ':rose:': '🌹',
//   ':cherry:': '🍒',
//   ':strawberry:': '🍓',
//   ':watermelon:': '🍉',
//   ':pineapple:': '🍍',
//   ':banana:': '🍌',
//   ':apple:': '🍎',
//   ':pear:': '🍐',
//   ':peach:': '🍑',
//   ':lemon:': '🍋',
//   ':grape:': '🍇',
//   ':melon:': '🍈',
//   ':coconut:': '🥥',
//   ':kiwi:': '🥝',
//   ':avocado:': '🥑',
//   ':broccoli:': '🥦',
//   ':carrot:': '🥕',
//   ':corn:': '🌽',
//   ':potato:': '🥔',
//   ':tomato:': '🍅',
//   ':eggplant:': '🍆',
//   ':pepper:': '🌶️',
//   ':bagel:': '🥯',
//   ':bread:': '🍞',
//   ':croissant:': '🥐',
//   ':pretzel:': '🥨',
//   ':cheese:': '🧀',
//   ':egg:': '🍳',
//   ':bacon:': '🥓',
//   ':pancakes:': '🥞',
//   ':sandwich:': '🥪',
//   ':burger:': '🍔',
//   ':pizza:': '🍕',
//   ':taco:': '🌮',
//   ':burrito:': '🌯',
//   ':salad:': '🥗',
//   ':sushi:': '🍣',
//   ':ramen:': '🍜',
//   ':spaghetti:': '🍝',
//   ':steak:': '🥩',
//   ':fries:': '🍟',
//   ':hotdog:': '🌭',
//   ':popcorn:': '🍿',
//   ':cookie:': '🍪',
//   ':cake:': '🍰',
//   ':icecream:': '🍦',
//   ':doughnut:': '🍩',
//   ':chocolate:': '🍫',
//   ':coffee:': '☕',
//   ':tea:': '🍵',
//   ':beer:': '🍺',
//   ':wine:': '🍷',
//   ':cocktail:': '🍸',
//   ':champagne:': '🍾',
//   ':whiskey:': '🥃',
//   ':milk:': '🥛',
//   ':water:': '💧',
//   ':juice:': '🥤',
//   ':soda:': '🥤',
//   ':champagne_glass:': '🥂',
// };

// Function to convert text to emojis
// const convertTextToEmoji = (text) => {
//   // return text.replace(
//   //   /(<3|<\/3|:\)|:\(|:D|;\)|:P|:O|:o|:\||:\*|:\\|:\/|XD|xD|>:\(|:\]|:3|:S|:@|o:\)|O:\)|>:O|B\)|:-\)|:-\(|:-D|:-P|:-O|:-\||8\)|8\||>:D|<_<|>_>|(?:\^_\^)|\._\||T_T|D:|:\^\)|:-\*|\*_\*|O_O|:#|X\(|>:P|>:\)|:\/|\):\^|\):@|<:D|8-D|O_o|o_O|-__-|\:y:|\:n:|\:clap:|\:ok:|\:wave:|\:peace:|\:flex:|\:heart:|\:star:|\:fire:|\:100:|\:idea:|\:gift:|\:party:|\:thumbsup:|\:thumbsdown:|\:sun:|\:moon:|\:rain:|\:cloud:|\:flower:|\:tree:|\:earth:|\:cat:|\:dog:|\:bird:|\:fish:|\:horse:|\:unicorn:|\:panda:|\:bear:|\:lion:|\:tiger:|\:elephant:|\:zebra:|\:cow:|\:pig:|\:sheep:|\:monkey:|\:gorilla:|\:rabbit:|\:fox:|\:wolf:|\:deer:|\:bat:|\:whale:|\:dolphin:|\:shark:|\:octopus:|\:crab:|\:lobster:|\:shrimp:|\:butterfly:|\:bee:|\:ladybug:|\:ant:|\:spider:|\:scorpion:|\:snake:|\:lizard:|\:crocodile:|\:turtle:|\:frog:|\:mushroom:|\:cactus:|\:palm:|\:rose:|\:cherry:|\:strawberry:|\:watermelon:|\:pineapple:|\:banana:|\:apple:|\:pear:|\:peach:|\:lemon:|\:grape:|\:melon:|\:coconut:|\:kiwi:|\:avocado:|\:broccoli:|\:carrot:|\:corn:|\:potato:|\:tomato:|\:eggplant:|\:pepper:|\:bagel:|\:bread:|\:croissant:|\:pretzel:|\:cheese:|\:egg:|\:bacon:|\:pancakes:|\:sandwich:|\:burger:|\:pizza:|\:taco:|\:burrito:|\:salad:|\:sushi:|\:ramen:|\:spaghetti:|\:steak:|\:fries:|\:hotdog:|\:popcorn:|\:cookie:|\:cake:|\:icecream:|\:doughnut:|\:chocolate:|\:coffee:|\:tea:|\:beer:|\:wine:|\:cocktail:|\:champagne:|\:whiskey:|\:milk:|\:water:|\:juice:|\:soda:|\:champagne_glass:)/g,
//   //   (match) => emojiMap[match] || match
//   // );
//   const urlRegex = /(https?:\/\/?[^\s]*)/g;

//   // Split the text into parts: URLs and non-URL text
//   const parts = text.split(urlRegex);

//   // Map over parts, converting emojis in non-URL parts only
//   return parts
//     .map((part) => {
//       if (urlRegex.test(part)) {
//         // If it's a URL, return it unchanged
//         return part;
//       } else {
//         // Otherwise, replace emojis in the part
//         return part.replace(
//           /(<3|<\/3|:\)|:\(|:D|;\)|:P|:O|:o|:\||:\*|:\\|:\/|XD|xD|>:\(|:\]|:3|:S|:@|o:\)|O:\)|>:O|B\)|:-\)|:-\(|:-D|:-P|:-O|:-\||8\)|8\||>:D|<_<|>_>|(?:\^_\^)|\._\||T_T|D:|:\^\)|:-\*|\*_\*|O_O|:#|X\(|>:P|>:\)|:\/|\):\^|\):@|<:D|8-D|O_o|o_O|-__-|\:y:|\:n:|\:clap:|\:ok:|\:wave:|\:peace:|\:flex:|\:heart:|\:star:|\:fire:|\:100:|\:idea:|\:gift:|\:party:|\:thumbsup:|\:thumbsdown:|\:sun:|\:moon:|\:rain:|\:cloud:|\:flower:|\:tree:|\:earth:|\:cat:|\:dog:|\:bird:|\:fish:|\:horse:|\:unicorn:|\:panda:|\:bear:|\:lion:|\:tiger:|\:elephant:|\:zebra:|\:cow:|\:pig:|\:sheep:|\:monkey:|\:gorilla:|\:rabbit:|\:fox:|\:wolf:|\:deer:|\:bat:|\:whale:|\:dolphin:|\:shark:|\:octopus:|\:crab:|\:lobster:|\:shrimp:|\:butterfly:|\:bee:|\:ladybug:|\:ant:|\:spider:|\:scorpion:|\:snake:|\:lizard:|\:crocodile:|\:turtle:|\:frog:|\:mushroom:|\:cactus:|\:palm:|\:rose:|\:cherry:|\:strawberry:|\:watermelon:|\:pineapple:|\:banana:|\:apple:|\:pear:|\:peach:|\:lemon:|\:grape:|\:melon:|\:coconut:|\:kiwi:|\:avocado:|\:broccoli:|\:carrot:|\:corn:|\:potato:|\:tomato:|\:eggplant:|\:pepper:|\:bagel:|\:bread:|\:croissant:|\:pretzel:|\:cheese:|\:egg:|\:bacon:|\:pancakes:|\:sandwich:|\:burger:|\:pizza:|\:taco:|\:burrito:|\:salad:|\:sushi:|\:ramen:|\:spaghetti:|\:steak:|\:fries:|\:hotdog:|\:popcorn:|\:cookie:|\:cake:|\:icecream:|\:doughnut:|\:chocolate:|\:coffee:|\:tea:|\:beer:|\:wine:|\:cocktail:|\:champagne:|\:whiskey:|\:milk:|\:water:|\:juice:|\:soda:|\:champagne_glass:)/g,
//           (match) => emojiMap[match] || match
//         );
//       }
//     })
//     .join("");
// };

const convertTextToEmoji = (text) => {
  const replacedEmojiString = checkText(text);
  return replacedEmojiString;
};

const EmojiTextInput = ({ component: InputComponent, value, onChange, ...props }) => {
  const [inputValue, setInputValue] = useState(value || '');

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    const convertedValue = convertTextToEmoji(newValue);
    setInputValue(convertedValue);

    if (onChange) {
      e.target.value = convertedValue;
      onChange(e);
    }
  };

  return (
    <InputComponent
      {...props}
      value={inputValue}
      onChange={handleChange}
    />
  );
};

export default EmojiTextInput;
